import { Brand, Schema } from '@blade/std-lib'

export const DelugeIdTypeId = 'tradebot-tma/delugeId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DelugeIdTypeId = typeof DelugeIdTypeId

export type DelugeId = Brand.Branded<string, DelugeIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DelugeId = Brand.nominal<DelugeId>()

export const DelugeIdSchema = Schema.String.pipe(
  Schema.fromBrand(DelugeIdTypeId, DelugeId),
)
